import React from 'react';
import DSTruncatedTooltipText from '@elliemae/ds-truncated-tooltip-text';
import { BOX_TYPES } from '../constants.js';
import { Actions } from '../Actions.js';
import LabelElement from '../LabelElement.js';
import GroupBoxLabel from '../GroupBoxLabel.js';
import 'prop-types';
import 'styled-components';
import 'styled-system';
import '@elliemae/ds-system';
import '../ActionItem.js';

var DSGroupBoxHeader = function DSGroupBoxHeader(_ref) {
  var _ref$labelProps = _ref.labelProps,
      labelProps = _ref$labelProps === void 0 ? {
    labelText: '',
    borderBottom: false,
    id: 'ds-group-box__header'
  } : _ref$labelProps,
      _ref$rightActions = _ref.rightActions,
      rightActions = _ref$rightActions === void 0 ? [] : _ref$rightActions,
      _ref$centerActions = _ref.centerActions,
      centerActions = _ref$centerActions === void 0 ? [] : _ref$centerActions,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? BOX_TYPES.CATEGORY : _ref$type,
      noBorder = _ref.noBorder,
      isMain = _ref.isMain;
  var labelText = labelProps.labelText,
      borderBottom = labelProps.borderBottom,
      id = labelProps.id;
  return /*#__PURE__*/React.createElement(GroupBoxLabel, {
    borderBottom: borderBottom,
    isMain: isMain,
    noBorder: noBorder,
    type: type,
    id: id
  }, /*#__PURE__*/React.createElement(LabelElement, null, /*#__PURE__*/React.createElement(DSTruncatedTooltipText, {
    value: labelText
  })), /*#__PURE__*/React.createElement(Actions, {
    actions: centerActions,
    centerActions: centerActions.length > 0
  }), /*#__PURE__*/React.createElement(Actions, {
    actions: rightActions,
    rightActions: rightActions.length > 0
  }));
};

export { DSGroupBoxHeader };
//# sourceMappingURL=GroupHeader.js.map
